// Build a SurveyJS html value whose markup holds several translated strings:
//   html: locHtml((t) => `<h1>${t("splash.busy.title")}</h1>`)
// gives { default: <English html>, es: <Spanish html> } (the same shape as
// loc()), so survey.locale picks the language and the markup stays in code.
import { loc, LocText } from "../i18n/survey";

export function locHtml(build: (t: (key: string) => string) => string): LocText {
  return {
    default: build((key) => loc(key).default),
    es: build((key) => {
      const text = loc(key);
      return text.es ?? text.default;
    }),
  };
}
